export enum DragDropDevices {
  Dashboard = 'dashboard',
}
